import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { ReusableProvider } from "reusable"

import "./scss/style.scss";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const TheLayout = React.lazy(() => import("./containers/TheLayout"));

// Pages
//const LoginOld = React.lazy(() => import("./pages/login/LoginOld"));
const Login = React.lazy(() => import("./pages/login/Login"));
/*const Register = React.lazy(() => import("./pages/register/Register"));
const Page404 = React.lazy(() => import("./pages/page404/Page404"));
const Page500 = React.lazy(() => import("./pages/page500/Page500"));*/

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <React.Suspense fallback={loading}>
          <Switch>
            {/*<Route
              exact
              path="/loginOld"
              name="Login Page"
              render={(props) => <LoginOld {...props} />}
            />*/}
            <Route
              exact
              path="/login"
              name="OTP"
              render={(props) => <Login {...props} />}
            />

            <Route
              path="/"
              name="Home"
              render={(props) => <ReusableProvider><TheLayout {...props} /></ReusableProvider>}
            />
            {/*<Route
              exact
              path="/register"
              name="Register Page"
              render={(props) => <Register {...props} />}
            />
            <Route
              exact
              path="/404"
              name="Page 404"
              render={(props) => <Page404 {...props} />}
            />
            <Route
              exact
              path="/500"
              name="Page 500"
              render={(props) => <Page500 {...props} />}
            />
*/}
          </Switch>
        </React.Suspense>
      </BrowserRouter>
    );
  }
}

export default App;
